import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { IconSettings } from "@tabler/icons-react"
import clsx from "clsx"

interface Props {
  active: boolean
  onClick: () => void
}

export function SettingsButton({ active, onClick }: Props) {
  const { translate } = useTranslation()
  return (
    <button
      onClick={onClick}
      title={
        active
          ? translate("QMS/SETTINGS/CLOSE")
          : translate("QMS/SETTINGS/OPEN")
      }
      className={clsx(
        "ml-auto shrink-0 rounded p-1.5 transition-colors",
        active
          ? "bg-grey3 text-white"
          : "text-grey5 hover:bg-grey3 hover:text-white",
      )}
    >
      <IconSettings size={16} />
    </button>
  )
}
